export enum PropCategory {
  APPLIANCES = "APPLIANCES",
  FIXTURES = "FIXTURES",
  FURNITURE = "FURNITURE",
  FOLIAGE = "FOLIAGE",
  OTHER = "OTHER",
}
